/* eslint-disable class-methods-use-this */
export class Command {
  execute() {
    throw new Error("Execute method must be implemented");
  }

  undo() {
    throw new Error("Undo method must be implemented");
  }
}
